require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeSandbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _generalObserver = require("../general-observer");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CodeSandbox = function CodeSandbox(_ref) {
  var codeSandboxId = _ref.codeSandboxId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "codesandbox",
    title: "codeSandbox-".concat(codeSandboxId),
    className: "codesandbox-mdx-embed",
    src: "https://codesandbox.io/embed/".concat(codeSandboxId),
    allow: "geolocation; microphone; camera; midi; vr; accelerometer; gyroscope; payment; ambient-light-sensor; encrypted-media; usb",
    sandbox: "allow-modals allow-forms allow-popups allow-scripts allow-same-origin",
    style: {
      width: '100%',
      height: '500px',
      border: 0,
      borderRadius: '4px',
      overflow: ' hidden'
    }
  }));
};

exports.CodeSandbox = CodeSandbox;